import React from 'react'

const Section = ({ title, children }) => {
  return (
    <div className="mt-12 lg:mt-16">
      <h2 className="text-[24px] leading-[30px] lg:text-[32px] lg:leading-[40px] text-white font-semibold -tracking-[0.5px]">
        {title}
      </h2>
      <div className="mt-5 lg:mt-6 flex flex-col space-y-4 lg:space-y-5">
        {children}
      </div>
    </div>
  )
}

const Field = ({ label, children }) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-baseline">
      <span className="block text-[#666B71] lg:min-w-[260px] lg:pr-6">
        {label}
      </span>
      <span className="block text-[#DDDDDE] mt-1 lg:mt-0">{children}</span>
    </div>
  )
}

const About = () => {
  return (
    <div className="mx-5 lg:mx-10 mt-10 lg:mt-[50px] pb-20 lg:pb-[100px]">
      <div className="lg:max-w-[900px] lg:mx-auto text-[#B6BBC1] font-normal text-[16px] leading-[24px] lg:text-[20px] lg:leading-[32px]">
        <h1 className="text-[28px] leading-[34px] lg:text-[48px] lg:leading-[58px] text-[#DDDDDE] font-medium -tracking-[1px] lg:-tracking-[2px]">
          Сведения об организации и деятельности в области информационных
          технологий
        </h1>

        <Section title="Реквизиты организации">
          <Field label="Полное наименование">
            Общество с ограниченной ответственностью «ПРАЙС НИНДЗЯ»
          </Field>
          <Field label="Юридический адрес">
            123242, Россия, г. Москва, ул. Большая Грузинская, д. 20, помещ. 3/П
          </Field>
          <Field label="ИНН">9703250804</Field>
          <Field label="ОГРН">1267700222789</Field>
          <Field label="КПП">770301001</Field>
          <Field label="E-mail">
            <a
              href="mailto:hello@priceninja.ru"
              className="underline hover:duration-500 hover:text-white"
            >
              hello@priceninja.ru
            </a>
          </Field>
          <Field label="Телефон">
            <a
              href="tel:+79773333882"
              className="underline hover:duration-500 hover:text-white"
            >
              +7 977 333-38-82
            </a>
          </Field>
        </Section>

        <Section title="Виды деятельности">
          <Field label="Основной код ОКВЭД">
            62.01 «Разработка компьютерного программного обеспечения»
          </Field>
          <p>
            Код осуществляемой деятельности в области информационных технологий
            (в соответствии с приказом Минцифры России от 11.05.2023 № 449):
          </p>
          <ul className="flex flex-col space-y-3 list-disc pl-5 marker:text-[#666B71]">
            <li>
              2.01 — Реализация программ для ЭВМ, в том числе путём
              предоставления удалённого доступа посредством
              информационно-телекоммуникационной сети «Интернет» (SaaS).
            </li>
          </ul>
        </Section>

        <Section title="Описание деятельности">
          <p>
            ООО «ПРАЙС НИНДЗЯ» является разработчиком и правообладателем
            программного обеспечения «Прайс Ниндзя». Общество осуществляет
            деятельность в области информационных технологий, связанную с
            разработкой, развитием, адаптацией, модификацией и эксплуатацией
            собственного программного обеспечения «Прайс Ниндзя».
          </p>
          <p>
            «Прайс Ниндзя» — программный сервис для автоматизации управления
            ценами, мониторинга и анализа данных продавцов на электронных
            торговых площадках (маркетплейсах).
          </p>
          <p>
            Программное обеспечение «Прайс Ниндзя» позволяет пользователям
            автоматизировать процессы управления ценами на товары на основании
            заданных правил и алгоритмов, осуществлять мониторинг цен и других
            данных, получать и обрабатывать информацию с электронных торговых
            площадок, проводить анализ показателей продаж и юнит-экономики.
          </p>
          <p>
            ООО «ПРАЙС НИНДЗЯ» самостоятельно осуществляет разработку и развитие
            программного обеспечения, включая проектирование программной
            архитектуры, разработку программного кода, создание и
            совершенствование алгоритмов обработки данных, интеграцию с внешними
            информационными системами посредством API, тестирование, техническое
            сопровождение и дальнейшую модификацию программного обеспечения.
          </p>
          <p>
            Доступ к программному обеспечению «Прайс Ниндзя» предоставляется
            пользователям через информационно-телекоммуникационную сеть
            «Интернет» по модели SaaS (Software as a Service).
          </p>
        </Section>

        <Section title="Стоимость предоставления доступа к ПО">
          <p>
            Доступ к программному обеспечению «Прайс Ниндзя» предоставляется на
            условиях подписки. Актуальная информация о тарифах и стоимости
            доступа размещена на странице:{' '}
            <a
              href="https://priceninja.ru/"
              className="underline hover:duration-500 hover:text-white"
            >
              https://priceninja.ru/
            </a>
          </p>
        </Section>

        <Section title="Используемые технологии">
          <Field label="Языки программирования">
            PHP, JavaScript, TypeScript
          </Field>
          <Field label="Фреймворки и программное обеспечение">
            Laravel, Next.js, MySQL, ClickHouse
          </Field>
        </Section>
      </div>
    </div>
  )
}

export { About }
